import { BoxProps, Divider } from "@chakra-ui/react";
import { VeriHeading } from "@verivest/shared-components";
import React from "react";

interface InvestmentDetailsSectionHeadingProps {
  withDivider?: boolean;
  headingProps?: BoxProps;
}
export const InvestmentDetailsSectionHeading: React.FC<
  InvestmentDetailsSectionHeadingProps
> = ({ children, withDivider, headingProps }) => {
  return (
    <>
      <VeriHeading textStyle="h5" py="8px" {...headingProps}>
        {children}
      </VeriHeading>
      {withDivider && <Divider mb="16px" />}
    </>
  );
};
